module.exports = __webpack_public_path__ + "static/hotblack-events5-678d2e72147071e19a66b22ff804d5d9.jpg";